import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from '@angular/core';
import { Questions, SelectedOptionList } from 'src/app/common-class/questions';
import { Group, Matrix } from 'src/app/common-class/pages';
import { Answers } from 'src/app/common-class/answers';
import { CommonLogic } from 'src/app/COMMON-LOGIC/common-logic';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
declare let $: any;

@Component({
  selector: 'app-matrix-grid',
  templateUrl: './matrix-grid.component.html',
  styleUrls: ['./matrix-grid.component.css'],
})
export class MatrixGridComponent implements OnInit, OnChanges {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() groups: Group[];
  @Input() matrix: Matrix;
  @Input() isSubmitted: boolean;
  @Input() isMobile: boolean;
  @Input() DropDown: string;
  @Input() isNewParticipationButton: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();

  questions: Questions[];
  imgQuestion: Questions;
  firstQuestion: Questions;
  isNgAfter: boolean;
  count: number = 0;

  checkDrillDown: number = 0;
  prevValue: any;

  questionsArray: any;
  isEx: boolean;
  dropDownCount: number;
  MatrixQCount: number;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  isAutoScroll: boolean;
  isAnsChange: boolean = false;
  isSearchableDD: boolean = false;
  resetPageSub: any;
  isDisplayedPipeMessage: boolean;
  isAnswerPipingSubChar: boolean;
  isStandAloneGrid: boolean = false;
  MDDdropDownCount: number;
  Nomatchfound: string;
  surveyMessages: SurveyMessages;

  ngOnChanges(changes: SimpleChanges) {
    let change = changes['JsonData'];
    if (change != undefined) {
      let curVal = JSON.stringify(change.currentValue);
      let preVal = JSON.stringify(change.previousValue);
      if (curVal != preVal && preVal != undefined) {
        this.onLoadFilterObject();
        this.MDDdropDownCount = this.service.getMDDdropDownCount();
        if (this.questions.length > 0) {
          if (this.matrix.isBranchEnabled) {
            this.BranchingQuestionsHandling(true);
          }
          this.SortQuestions(false);
          this.ngAfterViewInit();
          this.isNgAfter = true;
          this.count = 0;
          this.questions = this.questions.filter((e) => !e.isHiddenQ);
                    this.changeDetect.detectChanges();
          setTimeout(() => {
            this.ngAfterViewInit();
            this.isNgAfter = true;
            this.count = 0;
          }, 0);
        }
      }
    }
  }

  constructor(
    private service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef,
    private previewData: PreviewData,
  ) { }

  ngOnInit() {
    if (this.questions == null) {
      this.isEx = this.service.getIsEx();
      this.surveyMessages = this.service.getSurveyMessages();
      this.onLoadFilterObject();
      this.questions = this.questions?.filter((e) => !e.isHiddenQ);
      this.MDDdropDownCount = this.service.getMDDdropDownCount();
      this.Nomatchfound = this.service.getSurveyMessages()?.Participation_Nomatchfound;
      if (this.questions?.length > 0) {
        if (
          this.questions.filter(
            (e) =>
              (e.qtype == 'GD' || e.qtype == 'RW') && e.Answers.length > this.MDDdropDownCount - 1,
          ).length > 0
        ) {
          this.isSearchableDD = true;
        }
        this.dropDownCount = this.service.getdropDownCount();
        if (this.matrix.isBranchEnabled) {
          this.BranchingQuestionsHandling(true);
        }
        this.SortQuestions();
        this.MatrixQCount = this.questions.length;
        this.isNewParticipation = this.service.isNewParticipation;
        this.surveyFormat = this.service.surveyFormat;
        this.newParticipationBtnText = this.service.newParticipationBtnText;
        this.isAutoScroll = this.service.isAutoScroll;
      }
    }
  }

  ngAfterViewInit() {
    if (window.navigator.userAgent.indexOf('Chrome') != -1) {
      $('.answerParent').css('width', 'calc(100% + 1px)');
    }
    if (this.questions.length == 0) {
      return;
    }
    if (
      (this.questions[0].isGroupRule && this.questions[0].isCQHide) ||
      (this.questions[0].isNOGroupRule && this.questions[0].isGroupCQHide)
    ) {
      return;
    }
    let self = this;
    let elemid = '#dv_mg_' + this.firstQuestion?.UniqueNumber;
    let widthArray = [];

    this.questionPositionHandle(elemid);

    this.GetTitleColumnWidth();

    const elem = document.getElementById(elemid); 

      if (elem) {
        $(elemid)
      .find('.sub-category-table')
      .each(function (i) {
        let currentValue = self.setColumnWidth($(this));
          widthArray.push(currentValue);
        });
      }
    
    $(elemid)
      .find('.sub-category-table')
      .each(function (i) {
        $(this)
          .find('.sub-category-td')
          .css('width', widthArray[i] + 'px');
        $(this)
          .find('.sub-category-td')
          .css('min-width', widthArray[i] + 'px');
        let tableWidth = $(this).find('.sub-category-td').length * widthArray[i];
        $(this).css('width', tableWidth + 'px');
          });

        
    setTimeout(() => {

      if (
        $(elemid).find('.main-matrix-table').length > 0 &&
        $(elemid).find('.main-matrix-table').outerWidth() <
          $(elemid).closest('.question-data').width()
      ) {
        $(elemid)
          .closest('.question-data')
          .find('legend.matrix-question')
          .outerWidth($(elemid).find('.main-matrix-table').outerWidth());
      } 
      
      }, 0);


    setTimeout(() => {
   if (
        $(elemid).find('.answer-option-wrapper').outerWidth() >
        $(elemid).closest('.question-data').outerWidth()
      ) {
        $(elemid).find('.div-scroll-btn').show();
      }
    }, 0);
    

   $(document).ready(function () {
     if (self.isSearchableDD && (!elem)) {
        $(elemid).find('.answer-option-wrapper').css('padding-bottom', '70px');
        $(elemid).find('.answer-option-wrapper').addClass('GridSearch');

      }

      $(elemid)
        .find('fieldset-wrapper-scroll')
        .scroll(function () {
          if ($('.RTLDir').length > 0) {
            if (
              $(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() <=
              $(this).outerWidth() + 5
            ) {
              $(this).parents('.divScroll').find('.div-scroll-btn').hide();
            } else if (
              $(this).find('.answer-option-wrapper').outerWidth() + $(this).scrollLeft() >
              $(this).outerWidth() + 5
            ) {
              $(elemid).parents('.divScroll').find('.div-scroll-btn').show();

              }
            } else {
              if (
              $(this).find('.answer-option-wrapper').outerWidth() - $(this).scrollLeft() <=
              $(this).outerWidth() + 5
            ) {
              $(this).parents('.divScroll').find('.div-scroll-btn').hide();
            } else {
              $(this).parents('.divScroll').find('.div-scroll-btn').show();
            }
            }
          });
        


      $(window).on('resize', function () {
        $('.main-matrix-table').each(function () {
          if ($(this).outerWidth() < $(this).closest('.question-data').width()) {
            $(this)
              .closest('.question-data')
              .find('legend.matrix-question')
              .outerWidth($(this).outerWidth());
          }else {
            $(this)
              .closest('.question-data')
              .find('legend.matrix-question')
              .outerWidth($(this).closest('.question-data').outerWidth() - 2);
          }
        });
      });
 });
    $('document').ready(function () {
      for (const question of self.questions) {
          if (
          $('#div_MDD_drilldown_' + question.UniqueNumber)
            .find('input.drill-down-input')
            .val() == ''
        ) {
          $('#div_MDD_drilldown_' + question.UniqueNumber)
            .find('input.drill-down-input')
            .removeClass('no-search-icon');
          } else {
             $('#div_MDD_drilldown_' + question.UniqueNumber)
            .find('input.drill-down-input')
            .addClass('no-search-icon');
          }
        let width = $('#div_MDD_drilldown_' + question.UniqueNumber).width();
        $('.drill-down-list-itemMessage_' + question.UniqueNumber).css(
          'width',
          width + 'px',
        );
        }
        });
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  onLoadFilterObject() {
      this.questions = JSON.parse(this.JsonData);

    if (
      this.previewData != undefined &&
      this.service.getPrevPgChnge() &&
      this.questions[0].AnsPipeCondition != 0 &&
      this.questions[0].AnsPipeCondition != 1 &&
      this.questions[0].AnsPipeCondition != 3 &&
      this.questions[0].AnsPipeCondition != 4 &&
      this.questions.find((e) => e.isMultiQuestionPiping) == undefined
    ) {
      this.isDisplayedPipeMessage = true;
    } else {
      this.isDisplayedPipeMessage = false;
    }

    let imgQn;
    if (this.isEx) {
      imgQn = this.questions?.find((e) => e.sub_qno == 1 || e.population_type != 5);
    } else {
      imgQn = this.questions?.find((e) => e.sub_qno == 1);
    }

    if (imgQn != undefined && imgQn != null) {
      this.imgQuestion = imgQn;
    }

    let fstQn = this.questions?.[0];
    if (fstQn != undefined && fstQn != null) {
      this.firstQuestion = fstQn;
    }
    if (this.questions?.find((e) => e.AnsPipeCondition > 1) != undefined && this.isDisplayQno) {
      this.isAnswerPipingSubChar = true;
    } else {
      this.isAnswerPipingSubChar = false;
    }
        this.questions = this.questions?.filter(
      (e) => e.population_type != 2 && e.population_type != 5,
    );
    this.questions = this.questions?.filter((e) => !e.isMultiQuestionPiping);
  }

  remainingChar(question: Questions): number {
    if (question.AnswerText != null) {
      return question.characterLimit - question.AnswerText.length;
    } else {
      return question.characterLimit;
    }
  }

  SortQuestions(isLoading: boolean = true) {
    if (this.groups[0].answer_style != 2 && this.groups[0].answer_style != 1) {
      this.questions.sort((n1, n2) => n1.sub_qno - n2.sub_qno);
    } else {
      this.questions.sort((n1, n2) => n1.qno - n2.qno && n1.sub_qno - n2.sub_qno);
    }
    let questionsArray = [];

    let standAloneQn = this.questions.find((e) => e.qtype == 'SR' || e.qtype == 'SC');

    if (standAloneQn != null && standAloneQn != undefined && !this.isMobile) {
      this.isStandAloneGrid = true;
    }

    if (this.isMobile || this.isStandAloneGrid) {
      let unique = this.questions
        .map((e) => e.qno)
        .filter((value, index, self) => self.indexOf(value) === index);

      for (let i = 0; i < unique.length; i++) {
        let questions = this.questions
          .filter((e) => e.qno == unique[i])
          .sort((n1, n2) => n1.qno - n2.qno);

        if (questions.length > 0) {
          if (this.groups[0].answer_style == 2) {
            let unique_2 = this.questions
              .map((e) => e.sub_qno)
              .filter((value, index, self) => self.indexOf(value) === index);
            if (isLoading && i == 0) {
              unique_2 = CommonLogic.MatrixListRandom(unique_2);
              this.service.setMatrixRandomList(this.matrix.matrix_id, unique_2);
            } else {
              unique_2 = this.service.getMatrixRandomList(this.matrix.matrix_id);
            }

            let questions_2 = [];
            for (const unique_2_item of unique_2) {
              questions_2.push(questions.find((e) => e.sub_qno == unique_2_item));
            }
            questions = questions_2;
          }

          if (this.isAnswerPipingSubChar) {
            for (const question of questions) {
              question.subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
            }
          }
          if (
            questions.filter(
              (e) => (e.isGroupRule && e.isCQHide) || (e.isNOGroupRule && e.isGroupCQHide),
            ).length == 0
          )
            questionsArray.push(questions);
        }
      }
    } else {
      let unique = this.questions
        .map((e) => e.sub_qno)
        .filter((value, index, self) => self.indexOf(value) === index);

      if (this.groups[0].answer_style != 1 && this.groups[0].answer_style != 2) {
        unique.sort((a, b) => parseInt(a.toString()) - parseInt(b.toString()));
      } else if (this.groups[0].answer_style == 2) {
        if (isLoading) {
          unique = CommonLogic.MatrixListRandom(unique);
          this.service.setMatrixRandomList(this.matrix.matrix_id, unique);
        } else {
          unique = this.service.getMatrixRandomList(this.matrix.matrix_id);
        }
      }

      for (let i = 0; i < unique.length; i++) {
        let questions = this.questions
          .filter((e) => e.sub_qno == unique[i])
          .sort((n1, n2) => n1.qno - n2.qno);

        if (questions.length > 0) {
          if (this.isAnswerPipingSubChar) {
            for (let j = 0; j < questions.length; j++) {
              questions[j].subQnoinChar = CommonLogic.Convert_To_Alpha(i + 1);
            }
          }
          if (questions.filter((e) => e.isCQHide).length == 0)
            questionsArray.push(questions);
        }
      }
    }

    this.questionsArray = questionsArray;
  }

  BranchingQuestionsHandling(isLoading: boolean = false) {
    let sourceGridQuestions = this.questions.filter((e) => e.group_no == this.matrix.SourceGrid);

    if (sourceGridQuestions != null && sourceGridQuestions.length > 0) {
      let targets = this.matrix.TargetGrid.toString().split(',');

      for (const sourceGridQuestion of sourceGridQuestions) {
        for (const target of targets) {
          let targetQuestions = this.questions.filter(
            (e) => e.group_no == parseInt(target) && e.sub_qno == sourceGridQuestion.sub_qno,
          );

          for (const targetQuestion of targetQuestions) {
            if (sourceGridQuestion.selectAnsValue > 0) {
              if (sourceGridQuestion.selectAnsValue > 0) {
                if (this.matrix.SourcePosition == 1) {
                  if (this.matrix.SourceNumber == sourceGridQuestion.selectAnsValue) {
                    this.EnabledAndDisabledQuestion(targetQuestion, false, isLoading);
                  } else {
                    this.EnabledAndDisabledQuestion(targetQuestion, true, isLoading);
                  }
                } else if (this.matrix.SourcePosition == 2) {
                  if (sourceGridQuestion.selectAnsValue <= this.matrix.SourceNumber) {
                    this.EnabledAndDisabledQuestion(targetQuestion, false, isLoading);
                  } else {
                    this.EnabledAndDisabledQuestion(targetQuestion, true, isLoading);
                  }
                } else if (this.matrix.SourcePosition == 3) {
                  if (sourceGridQuestion.selectAnsValue >= this.matrix.SourceNumber) {
                    this.EnabledAndDisabledQuestion(targetQuestion, false, isLoading);
                  } else {
                    this.EnabledAndDisabledQuestion(targetQuestion, true, isLoading);
                  }
                }
              }
            } else {
                this.EnabledAndDisabledQuestion(targetQuestion, true, isLoading);
            }
          }
        }
      }
    }
  }

  EnabledAndDisabledQuestion(question: Questions, isDisabled: boolean, isLoading: boolean) {
    if (isDisabled) {
      question.IsDisabled = true;

      if (question.isValid) {
        question.isValid = false;
      }

      if (question.AnswerText != null) {
        question.AnswerText = null;

        if (question.qtype == 'GD' || (question.qtype == 'RW' && question.qsubtype == 2)) {
          question.selectAnsValue = -1;
        } else {
          question.selectAnsValue = 0;
        }
        question.AnswerID = 0;
        question.selectedOptionList = [];

        if (question.Answers != null) {
            for (const answer of question.Answers) {
            answer.ControlAns = null;
          }
        }
      }
    } else {
      question.IsDisabled = false;
    }

    if (question.IsDisabled) {
     const dynamicId = 'Q' + question?.qno + '_' + question?.UniqueNumber + "_RS_Clear_Button";
      const clearButton = document.getElementById(dynamicId);
      if (clearButton) {
        (clearButton as HTMLElement).click();
      }
    }

    if (!isLoading) {
      this.UpdateChangeAnswersData(question);
    }
  }

  RandomAnswerHandling(question: Questions) {
    let currentIndex = question.Answers.length,
      temporaryValue,
      randomIndex;
    let updateItem = question.Answers.find((e) => e.isOther);

    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = question.Answers[currentIndex];
      question.Answers[currentIndex] = question.Answers[randomIndex];
      question.Answers[randomIndex] = temporaryValue;
    }
  }

  GetQuestionsString(question): string {
    if (this.GetGroupData(question.group_no).mgTextboxHeight > 1) {
      question.tHeight = this.GetGroupData(question.group_no).mgTextboxHeight;
    }

    if (question.AnswerText == null && question.mandatory) {
      question.isMandatoryInvalid = true;
    } else {
      question.isMandatoryInvalid = false;
    }

    return JSON.stringify(question);
  }

  GetQuestionNumber(group_no: number): number {
    if (this.questions != null) {
      return this.questions.find((e) => e.group_no == group_no).qno;
    }
  }


  GetColumnWidth(group_no: number): number {
    if (this.groups != null) {
      const elemId = '#dv_' + this.firstQuestion.UniqueNumber;
      const fullWidth = $(elemId).find('.fieldset-wrapper').outerWidth();
      const totalWidth = (this.groups.find((e) => e.group_no == group_no).colwidth / 100) * fullWidth;
      return totalWidth;
    }
  }

GetTitleColumnWidth() {
  if (this.matrix != null) {
    let totalWidth = 0;
      const elemId = '#dv_' + this.firstQuestion.UniqueNumber;
      const fullWidth = $(elemId).find('.fieldset-wrapper').outerWidth();
      if (this.matrix.subq_col_width == 0) {
      if (this.firstQuestion.uniform_width) {
        totalWidth = 253;
      } else {
        let maxTitleWidth = 0;
          $(elemId).find('.matrixTitleTd').css('white-space', 'nowrap');
          $(elemId)
            .find('.matrixTitleTd')
            .each(function (i) {
              if ($(this).outerWidth() > maxTitleWidth) {
                maxTitleWidth = $(this).outerWidth();
          }
        });

        if (maxTitleWidth > 253) {
          maxTitleWidth = 253;
        }

        totalWidth = maxTitleWidth;
        $(elemId).find('.matrixTitleTd').css('white-space', 'normal');
      }
    } else {
      totalWidth = (this.matrix.subq_col_width / 100) * fullWidth;
    }

 $(elemId)
        .find('.matrixTitleTd')
        .css('width', totalWidth + 'px');
      $(elemId)
        .find('.matrixTitleTd')
        .css('min-width', totalWidth + 'px');
  }
}


  GetTotalColumnWidth(): number {
    if (this.matrix != null) {
      const elemId = '#dv_' + this.firstQuestion.UniqueNumber;
      const fullWidth = Math.ceil($(elemId).find('.fieldset-wrapper').outerWidth());
      let totalWidth = (this.matrix.totalwidth / 100) * fullWidth;
      if (totalWidth == 0) {
        totalWidth = fullWidth;
      }
      return totalWidth - 1;
    }
  }



  GetVerticalSpace(): string {
    if (this.matrix != null) {
      switch (this.matrix.VerticalSpaceCount) {
        case 0:
          return '15px';
        case 1:
          return '30px';
        case 2:
          return '45px';
        case 3:
          return '60px';
        default:
          break;
      }
    }
  }

  GetColumnSpan(group_no: number): number {
    if (this.questions != null) {
      let question = this.questions.find((e) => e.group_no == group_no);

      if (
        question.qtype == 'T' ||
        question.qtype == 'GD' ||
        (question.qtype == 'RW' && question.qsubtype == 2)
      ) {
        return 1;
      } else {
        return question.Answers.length;
      }
    }
  }

  GetGroupTitle(group_no: number): string {
    if (this.groups != null) {
      return this.groups.find((e) => e.group_no == group_no).gtitle;
    }
  }

  GetGroupData(group_no: number): Group {
    if (this.groups != null) {
      return this.groups.find((e) => e.group_no == group_no);
    }
  }

  UpdateChangeAnswersData(question: Questions) {
    if (question.AnswerText != null) {
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
  }

  UpdateQuestionsData(question: Questions) {
    this.UpdateChangeAnswersData(question);
    let qn = this.questions.find((e) => e.UniqueNumber == question.UniqueNumber);
    this.questions[this.questions.indexOf(qn)] = question;

    if (this.matrix.isBranchEnabled) {
      this.BranchingQuestionsHandling();
    }
  }

  RadioButtonSelectedValue(answer: Answers, question: Questions) {
    if (answer.selectdId == 1) {
      this.RadioButtonClickEventHandling(answer, question);
    } else {
      for (let answerItem of question.Answers) {
            let ind = question.Answers.indexOf(answerItem);
        if (answer.ms_id === answerItem.ms_id) {
          answer.ControlAns = answer.value_text;
          answer.selectdId = 1;
          question.Answers[ind] = answer;
          question.AnswerID = answer.ms_id;
          question.selectAnsValue = answer.value_id;
          question.AnswerText = answer.ControlAns;
          question.pageto = answer.pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answer.isOther) {
            question.isOtherAnswer = true;
          } else {
            question.isOtherAnswer = false;
          }
        } else {
          question.Answers[ind].ControlAns = null;
          question.Answers[ind].selectdId = 0;
        }
      }
      this.changeDetect.detectChanges();
      this.UpdateChangeAnswersData(question);

      if (this.matrix.isBranchEnabled) {
        this.BranchingQuestionsHandling();
      }
    }
  }

  RadioButtonClickEventHandling(answer: Answers, question: Questions) {
    if (answer.selectdId == 0) {
      return;
    }
    if (this.questions != null) {
      answer.selectdId = 0;
      answer.ControlAns = null;
      let updateItem = question.Answers.find((e) => e.ms_id == answer.ms_id);
      let index = question.Answers.indexOf(updateItem);
      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;
      question.AnswerText = null;
      question.otherAnswer = null;
      question.isOtherAnswer = false;
      this.changeDetect.detectChanges();
      this.UpdateChangeAnswersData(question);

      if (this.matrix.isBranchEnabled) {
        this.BranchingQuestionsHandling();
      }

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }
    }
  }

  CheckBoxSelectedValue(answer: Answers, event: any, question: Questions) {
    question.isAlertDanger = false;

    let updateItem = question.Answers.find((e) => e.ms_id == answer.ms_id);
    let index = question.Answers.indexOf(updateItem);

    if (event) {
      this.AddSelectedValueList(answer, question);
      answer.selectdId = 1;
      question.Answers[index] = answer;
      question.pageto = answer.pageto;
      question.otherAnswer = null;

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = true;
      }

      if (answer.isOther) {
        question.isOtherAnswer = true;
      }
    } else {
      this.RemoveSelectedList(answer, question);

      answer.selectdId = 0;
      answer.ControlAns = null;

      if (answer.IsNoneAbove) {
        question.isValid = false;
      }

      question.Answers[index] = answer;
      question.AnswerID = 0;
      question.selectAnsValue = 0;
      question.pageto = 0;

      if (question.isSoftRequired) {
        question.isSoftRequiredHandle = false;
      }

      if (answer.isOther) {
        question.isOtherAnswer = false;
        question.otherAnswer = null;
      }
    }

    if (question.selectedOptionList.length > 0) {
      question.AnswerText = 'Selected Answer Option';
    } else {
      question.AnswerText = null;
    }
    this.changeDetect.detectChanges();
    this.UpdateChangeAnswersData(question);
  }

  AddSelectedValueList(answer: Answers, question: Questions) {
    let selectedOptionList: SelectedOptionList[];

    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
    } else {
      selectedOptionList = [];
    }

    selectedOptionList.push({
      value_id: answer.value_id,
      value_text: answer.value_text,
      isOther: answer.isOther,
    });

    question.selectedOptionList = selectedOptionList;
  }

  RemoveSelectedList(answer: Answers, question: Questions) {
    let selectedOptionList: SelectedOptionList[];

    if (question.selectedOptionList != null && question.selectedOptionList != undefined) {
      selectedOptionList = question.selectedOptionList;
      let selectedList = selectedOptionList.find((e) => e.value_id == answer.value_id);
      let curIndex = selectedOptionList.indexOf(selectedList);

      if (curIndex >= 0) {
        selectedOptionList.splice(curIndex, 1);
      }
    } else {
      selectedOptionList = [];
    }
    question.selectedOptionList = selectedOptionList;
  }

  DropDownSelectedValue(
    event: any,
    question: Questions,
    isSearchableDD: boolean = false,
    curVal: number = -1,
  ) {
    let value = event.target.value;
    if (isSearchableDD) {
      value = curVal;
    }

    if (value === '-1' || !value) {
      question.isOtherAnswer = false;
      question.selectAnsValue = -1;
      question.AnswerID = 0;
      question.AnswerText = null;

      if (question.Answers.find((e) => e.selectdId == 1) != undefined) {
        question.Answers.find((e) => e.selectdId == 1).selectdId = 0;
        question.Answers.find((e) => e.selectdId == 1).ControlAns = null;
      }
    } else {
      for (const answerItem of question.Answers) {
        if (value == answerItem.value_id) {
          event.selectdId = 1;
          answerItem.selectdId = 1;
          question.AnswerID = answerItem.ms_id;
          question.selectAnsValue = answerItem.value_id;
          question.AnswerText = answerItem.value_text;
          question.pageto = answerItem.pageto;
          question.otherAnswer = null;

          if (question.isSoftRequired) {
            question.isSoftRequiredHandle = true;
          }

          if (answerItem.isOther) {
            question.isOtherAnswer = true;
          } else {
            question.isOtherAnswer = false;
          }
        } else {
          answerItem.ControlAns = null;
          answerItem.selectdId = 0;
        }
      }
    }

    this.UpdateChangeAnswersData(question);


  }


  onBlurMethod(question: Questions) {
    if (question.AnswerText != null && question.AnswerText.replace(/\s/g, '') == '') {
      question.AnswerText = null;
      question.pageto = 0;
    } else {
      question.pageto = question.Answers[0].pageto;
    }
    this.UpdateChangeAnswersData(question);
  }

  ValidationForSubQuestionType(event: any, curVal: any, question: Questions) {
    if (curVal == '') {
      question.isValid = false;
      question.AnswerText = null;

      if (question.qsubtype == 31) {
        question.isReEnterEmailValid = false;
      }
      question.pageto = 0;
      this.UpdateChangeAnswersData(question);
      return;
    }

    if (question.qsubtype == 21) {
      if (curVal.indexOf(' ') == -1) {
        this.NumberValidation(event, curVal, question);
      } else {
        question.isValid = true;
      }
    } else if (question.qsubtype == 31) {
      this.EmailValidation(curVal, question);
    }
    question.pageto = question.Answers[0].pageto;
    this.UpdateChangeAnswersData(question);
  }

  keyup(question: Questions) {
    question.isValid = false;
  }

  EmailValidation(curVal: string, question: Questions) {
    const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);
    let isValid = regexp.test(curVal);

    if (isValid) {
      question.isValid = false;
    } else {
      question.isValid = true;
    }
  }

  NumberValidation(event: any, curVal: any, question: Questions) {
    let curValue1 = parseFloat(curVal);
    let min1 = parseFloat(question.num_range_1);
    let max1 = parseFloat(question.num_range_2);

    if (curVal != '') {
      if (isNaN(curVal) || curValue1 < min1 || curValue1 > max1) {
        question.isValid = true;
        return;
      } else {
        question.isValid = false;

        if (question.AllowOnlyInteger) {
          if (Number.isInteger(curValue1) && curVal.indexOf('.') < 0) {
            question.isValid = false;
          } else {
            question.isValid = true;
          }
        }
      }
    } else {
      question.isValid = true;
    }
  }

  RatingScaleHeaderText(question: Questions, index: number, answer: Answers): string {
    let groupData = this.groups.find((e) => e.group_no == question.group_no);

    if (groupData != undefined && groupData != null) {
      if (answer.value_id == 1) {
        return groupData.L_text;
      } else if (groupData.M_Pos == parseInt(answer.value_text)) {
        return groupData.M_text;
      } else {
        let max = question.Answers.reduce((prev, current) =>
          prev.value_id > current.value_id ? prev : current,
        );
        if (max != null && max != undefined) {
          if (max.weight == 0) {
            if (answer.value_text == '') {
              return 'N/A';
            } else if (answer.value_text != null) {
              if (
                max.value_id - 1 == answer.value_id &&
                answer.weight != null &&
                answer.weight != 0
              ) {
                return groupData.H_text;
              } else if (answer.value_text != null && max.value_id == answer.value_id) {
                let value: any = answer.value_text;
                if (answer.value_text.indexOf('N/A') < 0) {
                  answer.value_text = value + ' ' + 'N/A';
                }
                return '';
              }
            }
          } else if (max.value_id == answer.value_id && answer.weight != 0) {
            return groupData.H_text;
          }
        }
      }
    }
    return '';
  }

  GetAnswerHeader(group_no: number): Answers[] {
    if (this.questions != null) {
      let question = this.questions.find((e) => e.group_no == group_no);
      if (
        question.qtype != 'T' &&
        question.qtype != 'GD' &&
        !(question.qtype == 'RW' && question.qsubtype == 2)
      ) {
        return question.Answers;
      } else {
        return;
      }
    }
  }

  GetQuestion(group_no: number): Questions {
    return this.questions.find((e) => e.group_no == group_no);
  }

  setColumnWidth(obj) {
    let maxWidth = 0;
    obj.find('.sub-category-td').each(function () {
      if ($(this).hasClass('matrixRatingTd')) {
        if ($(this).outerWidth() > maxWidth) {
          maxWidth = $(this).outerWidth();
        }
      } else {
        if ($(this).outerWidth() > maxWidth) {
          maxWidth = $(this).width();
        }
      }
    });
  }



  getMatrixTitle(matrix_id: number): string {
    return this.service.getMatrixPiping(matrix_id);
  }

  questionPositionHandle(objId: any) {
    let unique = this.questions
      .map((e) => e.sub_qno)
      .filter((value, index, self) => self.indexOf(value) === index);

    if (this.groups?.[0].answer_style != 1 && this.groups?.[0].answer_style != 2) {
      unique.sort((a, b) => parseInt(a.toString()) - parseInt(b.toString()));
    } else if (this.groups[0].answer_style == 2) {
      unique = this.service.getMatrixRandomList(this.matrix.matrix_id);
    }

    for (let i = 0; i < 2; i++) {
      this.setTitleColumnPos(objId, this.matrix?.QPos, '', '', i, '', null);
    }
    for (let i = 0; i < unique.length; i++) {
      let questions = this.questions.filter((e) => e.sub_qno == unique[i]);
      if (questions.length > 0 && questions.filter((e) => e.isCQHide).length > 0) {
        unique.splice(i, 1);
        i--;
      }
    }

    for (let i = 0; i < unique.length; i++) {
      let questions = this.questions.filter((e) => e.sub_qno == unique[i]);
      if (questions.length > 0) {
        let arrayNum = '';
        if (this.isDisplayQno && this.groups[0].answer_style != 2) {
          arrayNum = questions[0].subQnoinChar;
        } else if (this.isDisplayQno && this.groups[0].answer_style == 2) {
          arrayNum = CommonLogic.Convert_To_Alpha(i + 1);
        }
        
        let arrayTitle = questions[0].piping
          ? questions[0].pipingQuationTitle
          : questions[0].qtitle;
        let questionID = 'lbl_MG_' + questions[0].UniqueNumber + '_SubQ';
        this.setTitleColumnPos(
          objId,
          this.matrix?.QPos,
          arrayTitle,
          arrayNum,
          i + 2,
          questionID,
          questions[0],
        );
      }
    }
  }

  setTitleColumnPos(
    obj: any,
    qpos: number,
    arrayTitle: string,
    subQ: string,
    index: number,
    questionID: string,
    Questions: Questions,
  ) {
    let SubQString = '';
    if (this.isDisplayQno) {
      if (subQ != '') {
        subQ = subQ + ' ';
      }
      SubQString = '<span>' + subQ + '</span>';
    }
    
    const elem = document.querySelector(obj);
    if (!elem) return;
    
    const rows = elem.querySelectorAll('.answer-option-wrapper.matrix-grid > table > tr');
    if (!rows || rows.length <= index) return;
    
    const row = rows[index] as HTMLElement;
    
    if (qpos == 0) {
     if (
        $(obj)
          .find('.answer-option-wrapper.matrix-grid > table > tr')
          .eq(index)
          .children('td')
          .eq(0)
          .hasClass('matrixTitleTd')
      ) {
        $(obj)
          .find('.answer-option-wrapper.matrix-grid > table > tr')
          .eq(index)
          .children('td')
          .eq(qpos)
          .remove();
        }
      
      if (index == 0 || index == 1) {
          $(obj)
          .find('.answer-option-wrapper.matrix-grid > table > tr')
          .eq(index)
          .children('td')
          .eq(qpos)
          .before('<td class="matrixTitleTd"></td>');
      } else {
        
        if (
          (Questions != null &&
            this.groups.length == 1 &&
            Questions.mandatory &&
            this.isMandatoryUpfront) ||
          (this.groups.length == 1 &&
            Questions.mandatory &&
            this.isSubmitted &&
            Questions.AnswerText == null)
        ) {
          $(obj)
            .find('.answer-option-wrapper.matrix-grid > table > tr')
            .eq(index)
            .children('td')
            .eq(qpos)
            .before(
              '<td class="matrixTitleTd matrixMandatory" style="padding: 10px 0;position:relative;" >' +
                '<div><div class="isMandatory matrix-grid-mandatory"></div></div>' +
                SubQString +
                '<span id=' +
                questionID +
                '>' +
                arrayTitle +
                '</span>' +
                '</td>',
            );
        } else {
            $(obj)
            .find('.answer-option-wrapper.matrix-grid > table > tr')
            .eq(index)
            .children('td')
            .eq(qpos)
            .before(
              '<td class="matrixTitleTd" style="padding: 10px 0;" >' +
                SubQString +
                '<span id=' +
                questionID +
                '>' +
                arrayTitle +
                '</span>' +
                '</td>',
            );
        }
      }
    } else {
      qpos = qpos - 1;
       if (
        $(obj)
          .find('.answer-option-wrapper.matrix-grid > table > tr')
          .eq(index)
          .children('td')
          .eq(qpos + 1)
          .hasClass('matrixTitleTd')
      ) {
        $(obj)
          .find('.answer-option-wrapper.matrix-grid > table > tr')
          .eq(index)
          .children('td')
          .eq(qpos + 1)
          .remove();
      }
      
      if (index == 0 || index == 1) {
           $(obj)
          .find('.answer-option-wrapper.matrix-grid > table > tr')
          .eq(index)
          .children('td')
          .eq(qpos)
          .after('<td class="matrixTitleTd" style="padding-left: 15px;"></td>');
      } else {
        if (
          (Questions != null &&
            this.groups.length == 1 &&
            Questions.mandatory &&
            this.isMandatoryUpfront) ||
          (Questions.mandatory && this.isSubmitted && Questions.AnswerText == null)
        ) {
 $(obj)
            .find('.answer-option-wrapper.matrix-grid > table > tr')
            .eq(index)
            .children('td')
            .eq(qpos)
            .after(
              '<td class="matrixTitleTd matrixMandatory grid-border grid-border-inverse" style="padding: 10px 0 10px 15px;position:relative;" >' +
                '<div><div class="isMandatory matrix-grid-mandatory "></div></div>' +
                SubQString +
                '<span id=' +
                questionID +
                '>' +
                arrayTitle +
                ' </span>' +
                '</td>',
            );
        } else {
          $(obj)
            .find('.answer-option-wrapper.matrix-grid > table > tr')
            .eq(index)
            .children('td')
            .eq(qpos)
            .after(
              '<td class="matrixTitleTd grid-border grid-border-inverse" style="padding: 10px 0 10px 15px;" >' +
                SubQString +
                '<span id=' +
                questionID +
                '>' +
                arrayTitle +
                ' </span>' +
                '</td>',
            );
          }
        }
    }
  }

  ngOnChangesEventHandle(no: number) {
    if (no == this.questionsArray.length - 1) {
      this.ngAfterViewInit();
      this.count++;
    }
  }

  setLastRowPadding() {
    const elemid = this.firstQuestion.UniqueNumber + '_table';
    const element = document.getElementById(elemid);
    if (!element) return;
    
    for (const qn of this.questionsArray[this.questionsArray.length - 1]) {

      if (qn.isValid && qn.qtype == 'T') {
        element.classList.add('a-strip-bottom-table');
        return;
      }
    }
    element.classList.remove('a-strip-bottom-table');
  }

  setDrillDownValue(event: any, question: Questions, self, curVal: number) {
    self.DropDownSelectedValue(event, question, true, curVal);
    
    const drillDownContainer = document.getElementById(
      'div_MDD_drilldown_' + question.UniqueNumber,
    );
    if (!drillDownContainer) return;

    const inputElement = drillDownContainer.querySelector(
      'input.drill-down-input',
    ) as HTMLInputElement;
    if (!inputElement) return;
    
    if (inputElement.value === '') {
      inputElement.classList.remove('no-search-icon');
    } else {
      inputElement.classList.add('no-search-icon');
    }
  }

  showDDList(event) {
    const target = event.target;
    
    // Check if the parent has the 'showDrillList' class
    if (target.closest('.showDrillList')) {
      // If it does, remove the class and set aria-expanded to false
      const drillDownSearch = target.closest('.drill-down-search');
      drillDownSearch.classList.remove('showDrillList');
      
      const drillDownInput = target.closest('.drill-down-input');
      if (drillDownInput) {
        drillDownInput.setAttribute('aria-expanded', 'false');
      }
    } else {
      // Remove the class from all drill-down-search elements
      const allDrillDownSearches = document.querySelectorAll('.drill-down-search');
      allDrillDownSearches.forEach((element) => {
        element.classList.remove('showDrillList');
      });
      
      // Add the class to the current drill-down-search
      const drillDownSearch = target.closest('.drill-down-search');
      if (drillDownSearch) {
        drillDownSearch.classList.add('showDrillList');
        
        // Focus on the drill-down-input
        const drillDownInput = drillDownSearch.querySelector('.drill-down-input');
        if (drillDownInput) {
          drillDownInput.focus();
        }
        
        // Show all drill-down-list-item elements
        const listItems = drillDownSearch.querySelectorAll('.drill-down-list-item');
        listItems.forEach((item) => {
          (item as HTMLElement).style.display = 'block';
        });
        
        // Set the z-index of the parent td
        const parentTd = target.closest('td');
        if (parentTd) {
          parentTd.style.zIndex = '2';
        }
      }
    }
  }

  selectDDListItem(event, question: Questions) {
    const target = event.target;
    const drillDownSearch = target.closest('.drill-down-search');
    if (!drillDownSearch) return;
    
    // Clear input value
    const drillDownInput = drillDownSearch.querySelector('.drill-down-input') as HTMLInputElement;
    if (drillDownInput) {
      drillDownInput.value = '';
    }
    
    // Reset list items display and highlighting
    const listItems = drillDownSearch.querySelectorAll('.drill-down-list-item');
    listItems.forEach((item) => {
      const htmlItem = item as HTMLElement;
      const originalValue = htmlItem.getAttribute('ogListValue') || '';
      htmlItem.innerHTML = originalValue;
      htmlItem.innerHTML = this.highlight(htmlItem.innerHTML, '');
    });
    
    // Get selected values
    const itemText = target.getAttribute('ogListValue') || '';
    const itemValue = target.getAttribute('list-value') || '';
    
    // Update select dropdown value
    const selectElement = drillDownSearch.querySelector('select') as HTMLSelectElement;
    if (selectElement) {
      selectElement.value = itemValue;
    }
    
    // Update input field with selected text
    if (drillDownInput) {
      drillDownInput.value = itemText;
    }
    
    // Hide dropdown
    drillDownSearch.classList.remove('showDrillList');
    
    // Reset z-index on parent td
    const parentTd = target.closest('td');
    if (parentTd) {
      parentTd.style.zIndex = '0';
    }
    
    // Set drill down state and update value
    this.checkDrillDown = 1;
    this.setDrillDownValue(event, question, this, parseInt(itemValue));
  }

  setDDListItem(event, question: Questions) {
    const target = event.target;
    
    setTimeout(() => {
      if (this.checkDrillDown === 0 && this.checkDrillDown !== undefined) {
        const drillDownSearch = target.closest('.drill-down-search');
        if (!drillDownSearch) return;
        
        const input = drillDownSearch.querySelector('.drill-down-input') as HTMLInputElement;
        if (!input) return;
        
        const ddSearchValue = input.value.toLowerCase();
        
        if (ddSearchValue !== '') {
          const ddListItems = Array.from(
            drillDownSearch.querySelectorAll('.drill-down-list-item'),
          ) as HTMLElement[];
          let foundMatch = false;
          
          // Check for exact match
          for (const item of ddListItems) {
            const originalValue = item.getAttribute('ogListValue') || '';
            item.innerHTML = originalValue;
            
            if (originalValue.toLowerCase() === ddSearchValue) {
              // Exact match found - update input to match original casing
              input.value = originalValue;
              
              // Set select value
              const selectElement = drillDownSearch.querySelector('select') as HTMLSelectElement;
              if (selectElement) {
                const itemValue = item.getAttribute('list-value');
                selectElement.value = itemValue || '';
                this.setDrillDownValue(event, question, this, parseInt(itemValue || '-1'));
              }
              
              // Hide drill-down search
              const td = target.closest('td');
              if (td) {
                td.style.zIndex = '0';
              }
              
              foundMatch = true;
              break;
            }
          }
          
          // If no match, clear input and reset question
          if (!foundMatch) {
            input.value = '';
            
            const selectElement = drillDownSearch.querySelector('select') as HTMLSelectElement;
            if (selectElement) {
              selectElement.value = '0';
            }
            
            question.AnswerText = null;
            this.setDrillDownValue(event, question, this, -1);
          }
        } else {
          // Empty input, clear question
          question.AnswerText = null;
          this.setDrillDownValue(event, question, this, -1);
        }
      }
    }, 0);
    
    // Reset z-index
    const td = target.closest('td');
    if (td) {
      td.style.zIndex = '0';
    }
    
    // Hide message after 1ms
    setTimeout(() => {
      const messageElements = Array.from(
        document.querySelectorAll('.drill-down-list-itemMessage_' + question.UniqueNumber),
      ) as HTMLElement[];

      messageElements.forEach((item) => {
        item.style.display = 'none';
      });
    }, 1);
  }

  filterDDSearch(event, question: Questions) {
    const target = event.target;
    const keyCode = event.keyCode || event.which;
    
    // Handle Enter key press or undefined key
    if (keyCode == 13 || keyCode == undefined) {
      event.preventDefault();
      target.blur();
      
      setTimeout(() => {
        const drillDownSearch = target.closest('.drill-down-search');
        if (drillDownSearch) {
          drillDownSearch.classList.remove('showDrillList');
        }
      }, 100);
    }
    
    setTimeout(() => {
      const keyCode = event.keyCode || event.which;
      const drillDownSearch = target.closest('.drill-down-search');
      
      if (!drillDownSearch) return;
      
      // Handle Tab key - close dropdown
      if (keyCode === 9) {
        drillDownSearch.classList.remove('showDrillList');
        return;
      }
      
      drillDownSearch.classList.add('showDrillList');
      const selectElement = drillDownSearch.querySelector('select');
      
      // Handle Down Arrow key
      if (keyCode == 40) {
        event.preventDefault();
        
         const visibleItems = Array.from(
          drillDownSearch.querySelectorAll('.drill-down-list-item'),
        ).filter((item) => (item as HTMLElement).style.display !== 'none');

        if (!visibleItems.length) return;

        const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
        const selectValue = selectElement ? parseInt(selectElement.value) : -1;
        const lastVisibleItemValue = visibleItems.length
          ? parseInt(
              (visibleItems[visibleItems.length - 1] as HTMLElement).getAttribute('list-value') ||
                '-1',
            )
          : -1;
          
        // If no selection or at the end of the list, select first item
        if (selectValue <= 0 || selectValue == lastVisibleItemValue) {
          const firstItem = visibleItems[0] as HTMLElement;
          const listValue = firstItem.getAttribute('list-value');
          
          if (selectElement && listValue) {
            selectElement.value = listValue;
          }
          
          if (currentActiveItem) {
            currentActiveItem.classList.remove('currentActiveDDITem');
          }
          
          firstItem.classList.add('currentActiveDDITem');
          if (selectElement) {
            target.value = selectElement.options[selectElement.selectedIndex].text;
          }
        } else {
          // Find the next item
          let nextItem = null;
          
          if (currentActiveItem) {
            // Find the current item's position
            const currentIndex = visibleItems.indexOf(currentActiveItem);
            
            // If not the last item, get the next one
            if (currentIndex < visibleItems.length - 1) {
              nextItem = visibleItems[currentIndex + 1] as HTMLElement;
            } else {
              nextItem = currentActiveItem as HTMLElement;
            }
          } else {
            // No selection, use first item
            nextItem = visibleItems[0] as HTMLElement;
          }
          
          if (nextItem) {
            const listValue = nextItem.getAttribute('list-value');
            if (selectElement && listValue) {
              selectElement.value = listValue;
            }
            
            if (selectElement) {
              target.value = selectElement.options[selectElement.selectedIndex].text;
            }
            
            if (currentActiveItem) {
              currentActiveItem.classList.remove('currentActiveDDITem');
            }
            
            nextItem.classList.add('currentActiveDDITem');
          }
        }
        
        // Handle scrolling
        const activeItem = drillDownSearch.querySelector('.currentActiveDDITem') as HTMLElement;
        const listContainer = drillDownSearch.querySelector('.drill-down-list') as HTMLElement;
        
        if (activeItem && listContainer) {
          const itemRect = activeItem.getBoundingClientRect();
          const containerRect = listContainer.getBoundingClientRect();
          
          if (itemRect.bottom > containerRect.bottom) {
            listContainer.scrollTop += (itemRect.bottom - containerRect.bottom);
          } else if (itemRect.top < containerRect.top) {
            listContainer.scrollTop -= (containerRect.top - itemRect.top);
          }
        }
      } 
      // Handle Up Arrow key
      else if (keyCode == 38) {
        event.preventDefault();
        
        const visibleItems = Array.from(
          drillDownSearch.querySelectorAll('.drill-down-list-item'),
        ).filter((item) => (item as HTMLElement).style.display !== 'none');

        if (!visibleItems.length) return;

        const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
        const selectValue = selectElement ? parseInt(selectElement.value) : -1;
        const firstVisibleItemValue = visibleItems.length
          ? parseInt((visibleItems[0] as HTMLElement).getAttribute('list-value') || '-1')
          : -1;
          
        // If no selection or at the beginning of the list, select last item
        if (selectValue <= 0 || selectValue == firstVisibleItemValue) {
          const lastItem = visibleItems[visibleItems.length - 1] as HTMLElement;
          const listValue = lastItem.getAttribute('list-value');
          
          if (selectElement && listValue) {
            selectElement.value = listValue;
          }
          
          if (currentActiveItem) {
            currentActiveItem.classList.remove('currentActiveDDITem');
          }
          
          lastItem.classList.add('currentActiveDDITem');
          if (selectElement) {
            target.value = selectElement.options[selectElement.selectedIndex].text;
          }
        } else {
          // Find the previous item
          let prevItem = null;
          
          if (currentActiveItem) {
            // Find the current item's position
            const currentIndex = visibleItems.indexOf(currentActiveItem);
            
            // If not the first item, get the previous one
            if (currentIndex > 0) {
              prevItem = visibleItems[currentIndex - 1] as HTMLElement;
            } else {
              prevItem = currentActiveItem as HTMLElement;
            }
          } else {
            // No selection, use last item
            prevItem = visibleItems[visibleItems.length - 1] as HTMLElement;
          }
          
          if (prevItem) {
            const listValue = prevItem.getAttribute('list-value');
            if (selectElement && listValue) {
              selectElement.value = listValue;
            }
            
            if (selectElement) {
              target.value = selectElement.options[selectElement.selectedIndex].text;
            }
            
            if (currentActiveItem) {
              currentActiveItem.classList.remove('currentActiveDDITem');
            }
            
            prevItem.classList.add('currentActiveDDITem');
          }
        }
        
        // Handle scrolling
        const activeItem = drillDownSearch.querySelector('.currentActiveDDITem') as HTMLElement;
        const listContainer = drillDownSearch.querySelector('.drill-down-list') as HTMLElement;
        
        if (activeItem && listContainer) {
          const itemRect = activeItem.getBoundingClientRect();
          const containerRect = listContainer.getBoundingClientRect();
          
          if (itemRect.bottom > containerRect.bottom) {
            listContainer.scrollTop += itemRect.bottom - containerRect.bottom;
          } else if (itemRect.top < containerRect.top) {
            listContainer.scrollTop -= containerRect.top - itemRect.top;
          }
        }
      } 
      // Other keys (filtering)
      else {
        const tdElement = target.closest('td');
        if (tdElement) {
          tdElement.style.zIndex = '2';
        }
        
        // Remove current active selection
        const currentActiveItem = drillDownSearch.querySelector('.currentActiveDDITem');
        if (currentActiveItem) {
          currentActiveItem.classList.remove('currentActiveDDITem');
        }
        
        // Reset select value
        if (selectElement) {
          selectElement.value = '-1';
        }
        
        const ddSearchValue = target.value.toLowerCase();
        
        if (ddSearchValue !== '') {
          let isShowMessage = false;
          const listItems = drillDownSearch.querySelectorAll('.drill-down-list-item');
          
          // Process each list item
          listItems.forEach((item) => {
            const element = item as HTMLElement;
            const originalValue = element.getAttribute('ogListValue') || '';
            element.innerHTML = originalValue;
            
            if (originalValue.toLowerCase().indexOf(ddSearchValue) !== -1) {
              element.style.display = 'block';
              element.innerHTML = this.highlight(element.innerHTML, ddSearchValue);
              isShowMessage = true;
            } else {
              element.style.display = 'none';
            }
          });
          
          // Show or hide "no matches found" message
          const messageElements = document.querySelectorAll(
            '.drill-down-list-itemMessage_' + question.UniqueNumber,
          );
          messageElements.forEach((msg) => {
            (msg as HTMLElement).style.display = isShowMessage ? 'none' : 'block';
          });

          // Check if there are any visible items
          const visibleItems = drillDownSearch.querySelectorAll(
            '.drill-down-list-item:not([style*="display: none"])',
          );

          if (visibleItems.length === 0) {
            drillDownSearch.classList.remove('showDrillList');
            if (tdElement) {
              tdElement.style.zIndex = '0';
            }
          } else {
            drillDownSearch.classList.add('showDrillList');
            if (tdElement) {
              tdElement.style.zIndex = '2';
            }
          }
        } else {
          // When search is empty, show all items
          const messageElements = document.querySelectorAll('.drill-down-list-itemMessage_' + question.UniqueNumber);
          messageElements.forEach(msg => {
            (msg as HTMLElement).style.display = 'none';
          });
          
          const listItems = drillDownSearch.querySelectorAll('.drill-down-list-item');
          listItems.forEach((item) => {
            const element = item as HTMLElement;
            element.style.display = 'block';
            element.innerHTML = element.getAttribute('ogListValue') || '';
          });
        }
        
        // Set checkDrillDown based on value change
        this.checkDrillDown = target.value != this.prevValue ? 0 : 1;
      }
    }, 1);
  }

 setPrevValue(event) {
  this.prevValue = event.target.value;
}

  highlight(s, search) {
    return s.replace(
      new RegExp(search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'),
      '<b>$&</b>',
    );
  }

  nextQuestion(event) {
    if (
      this.isNewParticipation &&
      (this.surveyFormat == 1 || this.surveyFormat == 2) &&
      this.MatrixQCount == 1 &&
      this.service.isAutoScroll
    ) {
      this.service.gotoNextQuestion(this.questions[0], event);
    }
  }

  gotoNextQuestion(question: Questions, event) {
    if (this.questions.filter((e) => e.isValid).length == 0) {
      this.service.gotoNextQuestion(question, event);
    }
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  closeDDList(event) {
    const target = event.target;
    
    // Clear the input value if it's not empty
    if (target.value !== '') {
      target.value = '';
    }
    
    // Remove the showDrillList class from the parent drill-down-search element
    const drillDownSearch = target.closest('.drill-down-search');
    if (drillDownSearch) {
      drillDownSearch.classList.remove('showDrillList');
    }
    
    // Set aria-expanded attribute to false
    target.setAttribute('aria-expanded', 'false');
  }

  getAnswerPipeMessage(): string {
    return this.service.getAnswerPipeMessage();
  }

  getHiddenQuestions(questions: Questions[], service: ParticipationDataService) {
    return questions.filter((e) => e.isCQHide).length == 0;
  }

  isPostEditDisable(question: Questions): boolean {
    if (
      this.service.getisEditPostPop() == true &&
      question.population_type != 4 &&
      question.population_type != 5
    ) {
      return true;
    }
    return false;
  }
}
